// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export interface CutItem {
    cutsNo: string;
    feets:  string;
}

export interface CutProductsState {
    isOpen: boolean;
    product?: CartLineModel | ProductContextModel;
}

const initialCutProductsState: CutProductsState = {
    isOpen: false,
};

const xCutProducts = createTypedReducerWithImmer(initialCutProductsState, {
    "xCutProducts/SetModalOpen": (
        draft: Draft<CutProductsState>,
        action: {
            isOpen: boolean;
            product?: CartLineModel | ProductContextModel;
        },
    ) => {
        draft.isOpen = action.isOpen;
        draft.product = action.product;
    },
});

(reducers as any).xCutProducts = xCutProducts;

export type xCutProductsState = {
    xCutProducts: CutProductsState;
} & ApplicationState;

type xCutProductsReducers = {
    cutProducts: typeof xCutProducts;
};

export type xCutProductsActions = Parameters<xCutProductsReducers[keyof xCutProductsReducers]>[1] | AnyAction;
